import { registerComponent } from "lib/components";
import { MonacoEditorApp } from "./main";

registerComponent({ MonacoEditorApp });
